/** The last 24 months, most recent first, as { value: 'YYYY-MM', label: 'September 2026' } */
export const buildMonthOptions = () => {
  const options = [];
  const cursor = new Date();
  cursor.setDate(1);
  for (let i = 0; i < 24; i += 1) {
    const value = `${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, '0')}`;
    options.push({
      value,
      label: cursor.toLocaleString('en-US', { month: 'long', year: 'numeric' }),
      inProgress: i === 0,
    });
    cursor.setMonth(cursor.getMonth() - 1);
  }
  return options;
};

/** The last completed calendar month, as 'YYYY-MM'. */
export const defaultMonth = () => {
  const cursor = new Date();
  cursor.setDate(1);
  cursor.setMonth(cursor.getMonth() - 1);
  return `${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, '0')}`;
};
